import type { ComponentProps } from 'react'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'

type Props = ComponentProps<typeof PayPalScriptProvider> & { pathname: string }

/** Keep SDK context across navigation; load the payment SDK when a payment page needs it. */
export default function PayPalPageProvider({ pathname, children, ...props }: Props) {
  const needsPaymentSdk = pathname === '/kasse'
    || pathname.startsWith('/bestellung/')
    || pathname === '/paypal-wallet-test'

  return <PayPalScriptProvider {...props} deferLoading={!needsPaymentSdk}>
    {children}
  </PayPalScriptProvider>
}
